import React, { Component } from 'react'

export default class RadioGroup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.initial,
    }
    this.onChange = this._onChange.bind(this)
  }

  _onChange(e) {
    this.setState({ value: e.target.value }, () => {
      this.props.onChange(this.state.value)
    })
  }

  render() {
    let radioIndex = 0
    const radioButtons = React.Children.map(this.props.children, radios => {
      if (radios.type.name === "t" || radios.type.name === "RadioButton") {
        return React.cloneElement(radios, {
          name: this.props.name,
          currentState: this.state.value,
          onChange: this.onChange,
          ariaDescribedby: this.props.ariaDescribedby,
          dataAtId: this.props.dataAtId,
          radioRef: radioIndex++ === 0 ? this.props.radioRef : null
        })
      }
      return React.cloneElement(radios)
    })

    return (
      <div className={this.props.className} aria-labelledby={this.props.ariaLabelledby} role="radiogroup">{radioButtons}</div>
    )
  }
}